export const PERMISSIONS_TO_VALIDATE_FOR = {
  NONE: 0,
  CREATE: 1,
  UPDATE: 2
} as const;
